module.exports = __webpack_public_path__ + "img/swiper2.a9a41e5c.png";